import styled from 'styled-components';
import { ShadowColor, SurfaceColor} from '../../Colors';

const defaultStyle =  {
	Wrapper : styled.div`
        background-color : ${SurfaceColor};
        border-radius : 5px;
        padding : 2rem;
        width : 700px;
        box-shadow: 0px 8px 16px 0px ${ShadowColor};
        & > p {
            padding : 1rem;
        }
    `
};

const mobileStyle = {
	Wrapper : styled.div`
        background-color : ${SurfaceColor};
        border-radius : 5px;
        padding : 2rem;
        box-shadow: 0px 8px 16px 0px ${ShadowColor};
        & > p {
            padding : 1rem;
        }
    `
};

export default defaultStyle;
export {mobileStyle};